const googleCalendar = {
  upcoming: "Ближайшие события",
  today: "Сегодня",
  tomorrow: "Завтра",
  allDay: "Весь день",
  noEvents: "Нет ближайших событий",
  noAccount: "Аккаунт Google Calendar не подключён",
  connectAccount: "Подключить аккаунт в Настройках",
  openInCalendar: "Открыть в Google Calendar",
  startsIn: "Начало через",
} as const;
export default googleCalendar;
